import { render, staticRenderFns } from "./SettingsView.vue?vue&type=template&id=160dc064&scoped=true"
import script from "./SettingsView.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SettingsView.vue?vue&type=style&index=0&id=160dc064&prod&scoped=true&lang=css"
import style1 from "./SettingsView.vue?vue&type=style&index=1&id=160dc064&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160dc064",
  null
  
)

export default component.exports